import { FC } from "react";
import styles from "./BPcases.module.css";
import { useNavigate } from "@tanstack/react-router";
import { Case } from "@shared/ui/Cases/Cases";
import { useGetCasesQuery } from "@entities/Case/CaseApi";
import { SuspenseLoader } from "@shared/ui/Loader";
import { Timer } from "@shared/ui/Timer";

// Типы для временных заглушек кейсов
interface ComingSoonCase {
  id: string;
  type: number;
  comingSoon: boolean;
}

export const SelectCasesPage: FC = () => {
  const navigate = useNavigate();
  const { data: casesData, isLoading, error } = useGetCasesQuery({ limit: 3 });

  const handleBack = () => {
    navigate({ to: "/shop" });
  };

  if (isLoading) return <SuspenseLoader />;
  if (error) return <div className={styles.error}>Failed to load cases</div>;
  if (!casesData?.cases) return null;

  // Создаем дополнительные кейсы с пометкой "Coming Soon"
  const comingSoonCases: ComingSoonCase[] = [
    {
      id: "cs-2",
      type: 7,
      comingSoon: true,
    },
    {
      id: "cs-3",
      type: 10,
      comingSoon: true,
    },
  ];

  return (
    <div className={styles.container}>
      <div className={styles.topContainer}>
        <div className={styles.topHeader}>
          <button className={styles.backToGames} onClick={handleBack}>
            <svg
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.14545 15.6818C8.5697 16.1061 9.25755 16.1061 9.68181 15.6818C10.1061 15.2576 10.1061 14.5697 9.68181 14.1454L3.53636 8L9.68181 1.85455C10.1061 1.4303 10.1061 0.742446 9.68181 0.318191C9.25755 -0.106064 8.5697 -0.106063 8.14545 0.318191L2 6.46364L0.463639 8L2 9.53636L8.14545 15.6818Z"
                fill="white"
              />
            </svg>
            BACK TO SHOP
          </button>
          <Timer />
        </div>
        <div className={styles.topContent}>
          <div className={styles.productsGrid}>
            {/* Отображаем реальные кейсы из API */}
            {casesData.cases.map((caseItem) => (
              <div key={caseItem.id} className={styles.case}>
                <Case
                  type={caseItem.numberOfGames}
                  id={caseItem.id}
                  price={caseItem.price}
                />
              </div>
            ))}

            {/* Отображаем кейсы Coming Soon */}
            {comingSoonCases.map((caseItem) => (
              <div key={caseItem.id} className={styles.case}>
                <Case type={caseItem.type} id={caseItem.id} comingSoon={true} />
              </div>
            ))}
          </div>
        </div>
        <div className={styles.footerTop}>
          <div className={styles.footerTop__text}>
            <span className={styles.h11}>CASES</span>
            <span className={styles.p}>
              Твой мини-баттлпасс на каждый день. Покупаешь за G-coin, рискуешь
              — можешь выбить скин в 2–3 раза дороже. Если не повезло — есть
              страховка
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
